// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"cbd4ad60","224":"688f2fad","338":"688f2fad","477":"89a336c2","513":"688f2fad","533":"db848511"}[chunkId] + ".chunk.css";
};